// extracted by mini-css-extract-plugin
export var activityContainer = "_ky-0";
export var typingIndicatorContainer = "_ky-1";
export var typingIndicatorDot = "_ky-2";
export var wave = "_ky-3";